import React from "react";
import { resetAccount } from "../../apis/Auth.Api";
import PopUp from "../../components/PopUp";
import { FaTimesCircle } from "react-icons/fa";
import { RectBtn } from "../../components/General";
import { useSelector } from "react-redux";
import { selectUserData } from "../../features/store";
import { useSnackbar } from "notistack";

const ResetAccountPopUp = ({ openReset, setOpenReset, selectedUser, apiRef }) => {
    const { enqueueSnackbar } = useSnackbar();
    async function confirmResetAccount() {
        let r = await resetAccount({ user_id: selectedUser.userId });
        if (!r.data.indicator) {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }
        enqueueSnackbar(r.data.message, { variant: "success" });

        apiRef.current.updateRows([{ id: selectedUser.id, reset: true }]);
        setOpenReset(false);
    }

    return (
        <PopUp width={60} height={50} switchOn={openReset}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Confirmation</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setOpenReset(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="reset-confirmation-wrapper">
                        <h4> Reset Account? </h4>
                        <p>
                            By confirming, the account
                            <strong>{" " + selectedUser.userId + " "}</strong>'s password will be reset
                        </p>
                        <div className="btn-wrapper">
                            <RectBtn onClick={confirmResetAccount}>
                                <p>Confirm</p>
                            </RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default ResetAccountPopUp;
